namespace $ {
	/** Restore known stacking slots without removing widgets added after the action. */
	export class $shm_hitalama_map_history_order {
		private static check(order: readonly string[]) {
			if(!Array.isArray(order) || order.some(id=>typeof id!=='string'||!id) || new Set(order).size!==order.length) {
				throw new Error('Некорректный порядок виджетов в истории карты')
			}
		}

		static merge(current: readonly string[], desired: readonly string[]) {
			this.check(current);this.check(desired)
			const live=new Set(current),known=new Set(desired)
			const retained=desired.filter(id=>live.has(id))
			let index=0
			return current.map(id=>known.has(id)?retained[index++]:id)
		}

		static matches(current: readonly string[], expected: readonly string[]) {
			this.check(current);this.check(expected)
			const live=new Set(current),known=new Set(expected)
			const retained=expected.filter(id=>live.has(id))
			const actual=current.filter(id=>known.has(id))
			return actual.length===retained.length && actual.every((id,index)=>id===retained[index])
		}
	}
}
